module.exports = __webpack_public_path__ + "img/restaurants-features-overview.c6330d1f.webp";